module.exports = __webpack_public_path__ + "img/Dantam Hair 20.c9a953f2.jpg";